import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './SwitchTick.scss';
import { SIZE } from '../../constants';
export { SIZE };
export function SwitchTick(props) {
    let className = '';
    className += props.size === SIZE.SML ? ' sg-switchTick-sml' : ' sg-switchTick-med';
    return (_jsxs("span", { className: 'sg-switchTick' + className, children: [_jsx("input", { type: 'checkbox', name: props.name, value: props.value, checked: props.isChecked, disabled: props.isDisabled, onChange: props.onChange, "data-test-id": props.testId }), _jsx("span", { className: 'sg-switchTick--toggle' })] }));
}
//# sourceMappingURL=SwitchTick.js.map